import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Radio,
} from '@material-ui/core';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';

const PageTable = (props) => {
  const { pages, formData, onChangePageOption } = props;
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [pageNo, setPageNo] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPageNo(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageNo(0);
  };

  const onChangeRadioOption = (currPage) => {
    return onChangePageOption(currPage);
  };

  return (
    <TableContainer>
      <Table className='list-table' aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell className='w-10' align='left'></TableCell>
            <TableCell className='w-30'>Page Name</TableCell>
            <TableCell className='w-60' align='center'>
              Status
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? pages.slice(pageNo * rowsPerPage, pageNo * rowsPerPage + rowsPerPage)
            : pages
          ).map((page, i) => (
            <TableRow
              key={i}
              className='border-white pointer'
              onClick={(e) => {
                onChangeRadioOption(page);
              }}
            >
              <TableCell>
                <Radio
                  color='primary'
                  value={page.id}
                  name='page'
                  onChange={() => onChangeRadioOption(page)}
                  checked={page.id === formData.pageId?.value}
                />
              </TableCell>
              <TableCell>{page.name}</TableCell>
              <TableCell>
                <div className='d-flex justify-content-center'>
                  <div
                    className={`${
                      page.status.toLowerCase() === 'draft'
                        ? 'pill-inactive theme-dark-green '
                        : 'pill-active '
                    } pill d-flex justify-content-center align-items-center`}
                  >
                    <span className='ms-1'>{page.status}</span>
                  </div>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow className='paginator'>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              count={pages.length}
              rowsPerPage={rowsPerPage}
              page={pageNo}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default PageTable;
